import { render, staticRenderFns } from "./FirewallList.vue?vue&type=template&id=2bd97e36&scoped=true"
import script from "./FirewallList.vue?vue&type=script&lang=js"
export * from "./FirewallList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd97e36",
  null
  
)

export default component.exports